import { render, staticRenderFns } from "./SchoolTeacherSelection.vue?vue&type=template&id=ce688016&"
import script from "./SchoolTeacherSelection.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports